import { useState } from 'react';

export function useLatestDefined<T>(value: T): NonNullable<T> | null {
   const [lastDefined, setLastDefined] = useState<NonNullable<T> | null>(null);

   if (value != null && value !== lastDefined) {
      setLastDefined(value as NonNullable<T>);
   }

   return value == null ? lastDefined : (value as NonNullable<T>);
}
